import React, { useState,useRef } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined,MoneyCollectOutlined,DollarCircleFilled,DashboardOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import VolumeConsumido from './VolumeConsumido';
import { useHistory } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import {Protegerotas} from './protegerotas';

function HGestaoEstatisc() {
    const history = useHistory();
    const onIdle=()=>{
        localStorage.setItem('log',false)
        history.push('/');
      }
      const ileTimeRed=useRef(null)
    const items: MenuProps['items'] = [
        {
            label: 'Relatorios de Cobranca',
            key: 'SubMenu',
            icon: <SettingOutlined />,
            children: [
              {
                type: 'group',
               
                children: [
                  {
                    label: 'Volume Adquirido',
                    key: 'Volume_Consumido',
                  },
                  {
                    label: 'Montante Adquirido',
                    key: 'Montante_Adquirido',
                  },
                
                    {
                      label: 'total adquirido pelo Cliente',
                      key: 'consumo_total',
                    },
                ],
              }
            ],
          },

      
        {
          label: 'Relatorios de Desempenho',
          key: 'app',
          icon: <DashboardOutlined />,
          children: [
            {
              type: 'group',
             
              children: [
                {
                  label: 'Cliente com compras Excessivas',
                  key: 'Cliente_com_consumo_Excessivo',
                },
                {
                  label: 'Cliente com compras Inadequado',
                  key: 'Cliente_com_consumo_Inadequado',
                },
                {
                    label: 'Cliente sem Compras',
                    key: 'sem_consumo',
                  },
                
                  
              ],
            }
          ],
          
        },
        
     
     
      ];
      const [current, setCurrent] = useState('mail');
      const onClick: MenuProps['onClick'] = (e) => {
        console.log('click ', e.key);
        setCurrent(e.key);
        if (e.key=="Volume_Consumido"){
            history.push('/home/Relatorios_estatisticos/volconsumo')
        }
        if (e.key=="Montante_Adquirido"){
          history.push('/home/Relatorios_estatisticos/montconsumo')
      }
     
      if (e.key=="consumo_total"){
        history.push('/home/Relatorios_estatisticos/cosumocliente')
    }
    if (e.key=="Cliente_com_consumo_Excessivo"){
      history.push('/home/Relatorios_estatisticos/consumoExcessivo')
  }
  if (e.key=="Cliente_com_consumo_Inadequado"){
    history.push('/home/Relatorios_estatisticos/consumoInaquado')
  }
  if (e.key=="sem_consumo"){
    history.push('/home/Relatorios_estatisticos/consumoSem')

  }
 
    
      };
    return (
          <div>
              {localStorage.setItem('location','Relatorios Estatisticos')}

        <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
   
      
  

    


    

    </div>
  )
}

export default HGestaoEstatisc